import TxpGriffinSettingsPayload from '../store/schema/TxpGriffinSettingsPayload';
import store from '../store/store';

/**
 * Returns the calendar mailbox configuration object which is observable
 */
export default function getTxpSettings(): TxpGriffinSettingsPayload {
    return store.txpSettings;
}
